import PropTypes from 'prop-types';
import React, { Component } from 'react';
import get from 'lodash/get';
import classNames from 'classnames/bind';
import QAndAItem from './QAndAItem';
import * as styles from './QAndA.css';

const cx = classNames.bind(styles);

export class QAndA extends Component {
    static propTypes = {
        qAndAData: PropTypes.arrayOf(PropTypes.object),
    };

    static defaultProps = {
        qAndAData: {},
    };

    render() {
        const { qAndAData } = this.props;
        const items = get(qAndAData, 'items', []);

        return (
            <div className={cx('wrapper')}>
                {items.map((item, index) => (
                    <QAndAItem item={item} key={index.toString()} />
                ))}
            </div>
        );
    }
}

export default QAndA;
